interface TabItem {
  id: string;
  label: string;
}

interface Props {
  tabs: readonly TabItem[];
  active: string;
  onChange: (id: string) => void;
}

export function TabNav({ tabs, active, onChange }: Props) {
  if (tabs.length === 0) return null;

  return (
    <nav className="tabnav" role="tablist" aria-label="Well sections">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={tab.id === active}
          className={tab.id === active ? 'tab is-active' : 'tab'}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
